import { mittInstance } from "@/constants/mittInstance"
import { SIZE_CHART_SKU } from "@/constants/size-chart-sku"
import { classnameMerge } from "@/util/classname-merge"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import {
  ComponentPropsWithoutRef,
  ElementRef,
  forwardRef,
  useEffect,
  useState,
} from "react"

const SizeChartDialog = () => {
  const [open, setOpen] = useState(false)
  const [sku, setSku] = useState("")

  useEffect(() => {
    const handler = ({ sku }: { sku: string }) => {
      if (!SIZE_CHART_SKU.includes(sku)) {
      }

      setSku(sku)
      setOpen(true)
    }

    mittInstance.on("showSizeChart", handler)

    return () => {
      mittInstance.off("showSizeChart", handler)
    }
  }, [])

  let sizeContent = null

  if (sku === "KYDH107CP") {
    sizeContent = chart1
  } else if (sku === "KYDH153CP") {
    sizeContent = chart2
  } else if (sku === "KYDH154CP") {
    sizeContent = chart3
  } else if (sku === "KYDH213CP") {
    sizeContent = chart4
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-h-full w-full max-w-[600px] overflow-auto">
        <DialogTitle />
        <div className="w-full bg-white">
          <div className="flex h-[50px] items-center justify-between border-b-1 border-solid border-[rgba(173,173,173,0.3)] px-2.5">
            <div className="font-poppins pl-2.5">Size Chart</div>
            <button
              type="button"
              onClick={() => {
                setOpen(false)
              }}
              className="relative flex h-full w-[50px] items-center justify-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="lucide lucide-x text-black h-6 w-6"
                viewBox="0 0 24 24"
              >
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="p-10">{sizeContent}</div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

const chart1 = (
  <table className={"border-b-0 mx-auto w-full table-auto pb-5"}>
    <tr>
      <th
        className={
          "font-poppins border-1 border-solid border-[#ccc] p-[10px] text-center text-primary"
        }
      >
        Size
      </th>
      <th
        className={
          "font-poppins border-1 border-solid border-[#ccc] p-[10px] text-center text-primary"
        }
      >
        Height
      </th>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        S
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        44 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        M
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        60 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        L
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        76 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        XL
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        92 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        XXL
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        108 inches
      </td>
    </tr>
  </table>
)

const chart2 = (
  <table className={"border-b-0 mx-auto w-full table-auto pb-5"}>
    <tr>
      <th
        className={
          "font-poppins border-1 border-solid border-[#ccc] p-[10px] text-center text-primary"
        }
      >
        Size
      </th>
      <th
        className={
          "font-poppins border-1 border-solid border-[#ccc] p-[10px] text-center text-primary"
        }
      >
        Height
      </th>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        M
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        60 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        L
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        76 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        XL
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        92 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        2XL
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        108 inches
      </td>
    </tr>
  </table>
)

const chart3 = (
  <table className={"border-b-0 mx-auto w-full table-auto pb-5"}>
    <tr>
      <th
        className={
          "font-poppins border-1 border-solid border-[#ccc] p-[10px] text-center text-primary"
        }
      >
        Size
      </th>
      <th
        className={
          "font-poppins border-1 border-solid border-[#ccc] p-[10px] text-center text-primary"
        }
      >
        Height
      </th>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        S
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        46 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        M
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        60 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        L
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        76 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        XL
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        92 inches
      </td>
    </tr>
  </table>
)

const chart4 = (
  <table className={"border-b-0 mx-auto w-full table-auto pb-5"}>
    <tr>
      <th
        className={
          "font-poppins border-1 border-solid border-[#ccc] p-[10px] text-center text-primary"
        }
      >
        Size
      </th>
      <th
        className={
          "font-poppins border-1 border-solid border-[#ccc] p-[10px] text-center text-primary"
        }
      >
        Height
      </th>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        S
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        44 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        M
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        60 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        L
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        76 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        XL
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        92 inches
      </td>
    </tr>
    <tr>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        XXL
      </td>
      <td
        className={
          "border-1 border-solid border-[#ccc] p-[10px] text-center font-sans"
        }
      >
        108 inches
      </td>
    </tr>
  </table>
)

const Dialog = DialogPrimitive.Root
const DialogPortal = DialogPrimitive.Portal

const DialogOverlay = forwardRef<
  ElementRef<typeof DialogPrimitive.Overlay>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={classnameMerge(
      "fixed inset-0 z-[400] bg-[rgba(0,0,0,.5)] data-[state=open]_animate-in data-[state=closed]_animate-out data-[state=closed]_fade-out-0 data-[state=open]_fade-in-0",
      className
    )}
    {...props}
  />
))

const DialogContent = forwardRef<
  ElementRef<typeof DialogPrimitive.Content>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <DialogPortal>
    <DialogOverlay />
    <DialogPrimitive.Content
      ref={ref}
      className={classnameMerge(
        " duration-200 fixed left-1/2 top-1/2 z-[500] -translate-x-1/2 -translate-y-1/2 shadow-lg data-[state=open]_animate-in data-[state=closed]_animate-out data-[state=closed]_fade-out-0 data-[state=open]_fade-in-0 data-[state=closed]_zoom-out-95 data-[state=open]_zoom-in-95 data-[state=closed]_slide-out-to-left-1/2 data-[state=closed]_slide-out-to-top-[48%] data-[state=open]_slide-in-from-left-1/2 data-[state=open]_slide-in-from-top-[48%] ",
        className
      )}
      {...props}
    >
      {children}
    </DialogPrimitive.Content>
  </DialogPortal>
))

const DialogTitle = forwardRef<
  ElementRef<typeof DialogPrimitive.Title>,
  ComponentPropsWithoutRef<typeof DialogPrimitive.Title>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Title ref={ref} className="hidden" {...props}>
    size chart dialog
  </DialogPrimitive.Title>
))

export default SizeChartDialog
